import LogoImg from '../../../assets/logo.png';
const Logo =()=>{
    return  <div className={`mb-4 max-w-[150px] w-[50%] md:w-[30%] m-auto mt-8 md:mt-auto`}>
    <img src={LogoImg} alt="companylogo" className='w-full'/>
</div>
}
export default Logo;